export const FLICKER_AVOIDANCE_DELAY_MS = 200;
